import { useAppSelector } from "app/redux-store-interactions";
import { selectIsProcoreDesign } from "slices/explorer";
import { ProcoreToolMode, selectActiveToolMode } from "slices/procoreUx";

/**
 * Whether the remove buttons on measurement labels are on offer. In Procore, measurements are only
 * edited from inside measure mode - but from any of its tools, so that e.g. a laser can be removed
 * while measuring object to object without switching tools first.
 */
export function useCanRemoveMeasurements() {
    const isProcoreDesign = useAppSelector(selectIsProcoreDesign);
    const toolMode = useAppSelector(selectActiveToolMode);
    return isProcoreDesign ? toolMode === ProcoreToolMode.Measure : true;
}
